export const animatedShapeLight = {
  position: 'relative',
  bg: 'grey/light/background',
  overflow: 'hidden',
  width: '100%',
  states: {
    '&:after': {
      content: "''",
      display: 'block',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      gradient: 'loading',
      animation: 'loading',
    },
  },
  variants: {
    rectangular: {
      height: 20,
    },
    round: {
      width: 20,
      height: 20,
      borderRadius: 'round',
    },
    semiRound: {
      borderRadius: 'xxs',
    },
  },
};
